import OvertimeDetail from './OvertimeDetail';

export default OvertimeDetail;
